import { ShieldCheck, Package, Wrench, Building2, Truck, Snowflake } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const COVERAGES = [
  {
    icon: ShieldCheck,
    title: "Primary Auto Liability",
    limits: "$750K – $5M",
    copy: "The legal backbone of every operation. FMCSA and state filings included, certificates issued in minutes, limits that satisfy any shipper.",
    featured: true,
    span: "lg:col-span-2",
  },
  {
    icon: Package,
    title: "Motor Truck Cargo",
    limits: "$100K – $1M",
    copy: "Protection for the freight you haul — from general commodities to high-value loads.",
    span: "",
  },
  {
    icon: Wrench,
    title: "Physical Damage",
    limits: "Collision & Comp",
    copy: "Your tractor and trailer repaired fast, with agreed-value options for owner-operators.",
    span: "",
  },
  {
    icon: Building2,
    title: "General Liability",
    limits: "$1M – $2M",
    copy: "Covers the exposures that happen off the road — premises, operations and more.",
    span: "",
  },
  {
    icon: Truck,
    title: "Bobtail / Non-Trucking",
    limits: "Headed home",
    copy: "Keeps you protected when you're driving without a trailer or off dispatch.",
    span: "",
  },
  {
    icon: Snowflake,
    title: "Trailer Interchange & Reefer",
    limits: "Add-on coverages",
    copy: "Interchange liability plus reefer breakdown coverage for temperature-controlled freight.",
    span: "lg:col-span-2",
  },
];

export const Coverage = () => (
  <section id="coverage" data-testid="coverage-section" className="bg-brand-paper py-16 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
          <div>
            <p className="eyebrow">Coverage Types</p>
            <h2 className="mt-4 max-w-xl font-display text-3xl font-bold tracking-tight text-brand-navy sm:text-4xl lg:text-[2.75rem] lg:leading-[1.1]">
              Every mile, every load, covered.
            </h2>
          </div>
          <p className="max-w-md text-base leading-relaxed text-slate-600">
            One broker, one renewal, one call — a complete commercial package built around how
            your fleet actually runs.
          </p>
        </div>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4" data-testid="coverage-grid">
        {COVERAGES.map((c, i) => (
          <Reveal key={c.title} delay={0.05 * i} className={c.span}>
            <div
              className={`group flex h-full flex-col rounded-3xl border p-7 transition-all duration-300 hover:-translate-y-1 ${
                c.featured
                  ? "border-transparent bg-brand-navy text-white shadow-xl shadow-slate-900/20"
                  : "border-slate-200 bg-white text-brand-navy shadow-sm hover:border-brand-blue/40 hover:shadow-xl hover:shadow-blue-900/5"
              }`}
              data-testid={`coverage-card-${i}`}
            >
              <div className="flex items-start justify-between">
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-2xl transition-colors ${
                    c.featured ? "bg-white/10 text-brand-orange" : "bg-brand-ice text-brand-blue"
                  }`}
                >
                  <c.icon className="h-5 w-5" />
                </span>
                <span
                  className={`rounded-full px-3 py-1 font-mono text-[10px] uppercase tracking-[0.15em] ${
                    c.featured ? "bg-white/10 text-white/80" : "bg-slate-100 text-slate-500"
                  }`}
                >
                  {c.limits}
                </span>
              </div>
              <h3 className="mt-5 font-display text-xl font-bold tracking-tight">{c.title}</h3>
              <p className={`mt-2 text-sm leading-relaxed ${c.featured ? "text-white/70" : "text-slate-600"}`}>
                {c.copy}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
